import { clsx, styx } from "modules/Utils";
import { CSSProperties } from "react";

interface ColorPickerInputProps {
    className: string;
    style?: CSSProperties;
    selectedColor: string | undefined;
    selectColor: (color: string) => void;
    onClick?: () => void;
}

const ColorPickerInput = ({
    className,
    style,
    selectedColor,
    selectColor,
    onClick,
}: ColorPickerInputProps) => {
    return (
        <div
            className={clsx(className, 'colorPickerInputComponent')}
            style={styx(sty.colorPickerInputComponent, style)}
        >
            {onClick ?
                <div
                    className="colorPickerBox"
                    style={{
                        height: 28,
                        width: 28,
                        flexShrink: 0,
                        marginRight: 8,
                        cursor: "pointer",
                        backgroundColor: selectedColor,
                        border: '1px solid black'
                    }}
                    onClick={onClick}
                />
                :
                <input
                    className="colorPickerBox"
                    style={sty.colorPickerBox}
                    type='color'
                    id='bg-color'
                    name='bgcolor'
                    value={selectedColor}
                    onChange={(e) => selectColor(e.target.value)}
                />
            }

            <input
                className="hexColorInput"
                value={selectedColor}
                style={sty.hexColorInput}
                onChange={(e) => {
                    let colorValue = e.target.value;
                    if (!colorValue.startsWith('#')) {
                        colorValue = '#' + colorValue.replace('#', '');
                    }
                    if (colorValue === '') {
                        colorValue = '#';
                    }
                    selectColor(colorValue);
                }}
                maxLength={7}
            />
        </div>
    )
}

const sty: Record<string, CSSProperties> = {
    colorPickerInputComponent: {
        display: "flex",
        alignItems: "center",
        border: `1px solid #ADB7BC`,
        padding: 8,
        paddingRight: 12,
        borderRadius: 12,
        height: 48,
    },
    hexColorInput: {
        width: 75,
        height: 32,
        fontFamily: "DIN",
        fontSize: 18,
        outline: "none",
    },
    colorPickerBox: {
        border: "none",
        background: "transparent",
        height: 34,
        width: 31,
        marginRight: 8,
        cursor: "pointer",
    },
}

export default ColorPickerInput;